import { Video, AudioLines, Gauge } from "lucide-react";
import { SectionHead } from "./SectionHead";
import { Reveal } from "./Reveal";
import { SpecTables } from "./SpecTables";
import { useSection } from "../../lib/content";

const ICONS = [Video, AudioLines, Gauge];

export const WhatsBetter = () => {
  const c = useSection("whatsBetter");

  return (
    <section id="whats-better" className="relative bg-white py-28 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <SectionHead chapter="04" eyebrow={c.eyebrow} title={c.title} lead={c.lead} />
        <div className="mt-16 grid lg:grid-cols-3 gap-5">
          {c.pillars.map((p, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={p.title} delay={i * 0.12} className="h-full">
                <div className="group relative h-full rounded-2xl border border-[#2a2a2a] bg-[#1a1a1a] p-8 overflow-hidden transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1.5 hover:shadow-[0_28px_56px_-24px_rgba(15,23,42,0.28)] hover:border-[#024AD8]">
                  <span className="absolute -top-4 -right-2 font-display font-extrabold text-8xl text-[#2e2e2e] group-hover:text-[#3a3a3a] transition-colors duration-500 select-none">
                    {i + 1}
                  </span>
                  <span className="relative w-12 h-12 rounded-2xl bg-[#024AD8] text-white grid place-items-center shadow-[0_10px_24px_rgba(2,74,216,0.35)]">
                    <Icon className="w-5 h-5" />
                  </span>
                  <h3 className="relative mt-7 font-display text-xl sm:text-2xl font-bold tracking-tight text-white">
                    {p.title}
                  </h3>
                  <p className="relative mt-3 text-sm text-slate-400 leading-relaxed">{p.desc}</p>
                  <ul className="relative mt-6 space-y-2.5">
                    {p.points.map((point) => (
                      <li key={point} className="flex items-start gap-2.5 text-sm text-slate-300">
                        <span className="mt-[7px] w-1.5 h-1.5 rounded-full bg-[#FF5050] shrink-0" />
                        {point}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            );
          })}
        </div>
        <SpecTables />
      </div>
    </section>
  );
};
